import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RouterOutlet } from '@angular/router';
import { HeaderService } from '@services/header.service';
import { User } from '@app/shared/models/user.interface';
import { Building } from '@app/shared/models/building.interface';
import { BuildingAuthorityType } from '@app/shared/models/building-authority-type';
import { hasBuildingAuthority } from '@app/administration/layout/administration-tabs';
import { Tab } from '@components/tabs/tab.interface';
import { TabsComponent } from '@components/tabs/tabs.component';

@Component({
  selector: 'app-integrations',
  imports: [TabsComponent, RouterOutlet],
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.scss'
})
export class IntegrationsComponent implements OnInit {
  buildingId: number;
  floorId: number;
  building: Building;
  user: User;
  tabLinks$: Observable<Tab[]> = of([
    {
      path: 'areas',
      name: 'BACnet',
      dataCy: 'integrations-areas-tab',
      isAuthorized: hasBuildingAuthority(BuildingAuthorityType.MANAGE_BACNET_AREAS)
    },
    {
      path: 'siem',
      name: 'SIEM',
      dataCy: 'integrations-siem-tab',
      isAuthorized: hasBuildingAuthority(BuildingAuthorityType.MANAGE_AUDIT)
    }
  ]);

  constructor(private headerService: HeaderService) {}

  ngOnInit(): void {
    this.headerService.showBuildingsMenu();
    this.headerService.showUserMenu();
    this.headerService.showSiteMenu();
    this.headerService.showSessionMenu();
    this.headerService.hideFloorsMenu();
  }
}
